import {
  Box,
  BoxProps,
  SxProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import dayjs from "dayjs";
import { capitalize } from "lodash";
import React, { memo, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useLocales } from "../../hooks/useLocales";
import { useAuth } from "../../hooks/useAuth";
import { formatDate } from "../../shared/utils/DateUtils";

type headerProps = {
  text: string | React.ReactNode;
  date?: string;
  children?: ReactNode;
  leftChildren?: ReactNode;
  dateEnabled?: boolean;
  titleProps?: any;
  dateStyle?: SxProps;
  boxProps?: BoxProps;
};
function Header({
  titleProps,
  text,
  children,
  date,
  dateEnabled = true,
  leftChildren,
  dateStyle,
  boxProps,
}: headerProps) {
  const { t } = useTranslation();
  const { currentLang } = useLocales();
  const { getUserDateFormat } = useAuth();
  return (
    <Box
      display={"flex"}
      flexDirection={{ md: "row", xs: "column" }}
      justifyContent={"space-between"}
      alignItems={{ md: "center", xs: "self-start" }}
      gap={2}
    >
      <Box
        display={"flex"}
        {...boxProps}
        flexDirection={{ md: "row", xs: "column" }}
        gap={1}
      >
        {leftChildren}
        <Box
          display={"flex"}
          alignItems={{ xs: "center", md: "flex-start" }}
          flexDirection={"column"}
          justifyContent={"space-around"}
        >
          <Typography {...titleProps} variant="h4">
            {typeof text === "string" ? t(text) : text}
          </Typography>
          {dateEnabled && (
            <Typography sx={dateStyle} variant="caption">
              {date ??
                formatDate(
                  new Date().toISOString(),
                  getUserDateFormat,
                  currentLang as any,
                )}
            </Typography>
          )}
        </Box>
      </Box>

      {children}
    </Box>
  );
}

export default memo(Header);
